<script setup>
defineProps({
  stroke: {
    type: String,
    default: 'currentColor',
  },
});
</script>

<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.75 4.375H17.5"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.625 2.5V6.25"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.42188 16.875C3.1903 15.5449 4.29517 14.4404 5.62554 13.6726C6.95591 12.9047 8.46491 12.5006 10.001 12.5006C11.537 12.5006 13.046 12.9048 14.3764 13.6727C15.7068 14.4406 16.8116 15.545 17.58 16.8751"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 12.5C12.7614 12.5 15 10.2614 15 7.5C15 4.73858 12.7614 2.5 10 2.5C7.23858 2.5 5 4.73858 5 7.5C5 10.2614 7.23858 12.5 10 12.5Z"
      :stroke="stroke"
      stroke-width="2"
      stroke-miterlimit="10"
    />
  </svg>
</template>
